import { render, staticRenderFns } from "./ParentDialogPopup.vue?vue&type=template&id=ddc85c32&scoped=true"
import script from "./ParentDialogPopup.vue?vue&type=script&lang=js"
export * from "./ParentDialogPopup.vue?vue&type=script&lang=js"
import style0 from "./ParentDialogPopup.vue?vue&type=style&index=0&id=ddc85c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc85c32",
  null
  
)

export default component.exports